export const ETC_SLICE_VALUE = 11;
export const PAYOUT_PAUSE_IN_DAYS = 3;